module.exports = __webpack_public_path__ + "img/xiaolongxia.bab5020b.jpg";